import React from 'react';
import { IconButton, IconButtonSize, IconButtonType, IconButtonVariant } from '@ids/react-icon-button';
import { Ui24MoreVertical } from '@ids/react-icons';

const ThreeDotIcon = ({ onClick }) => {
  return (
    <IconButton
      type={IconButtonType.PLAIN}
      variant={IconButtonVariant.QUIET}
      size={IconButtonSize.MEDIUM}
      onClick={onClick}>
      {<Ui24MoreVertical />}
    </IconButton>
  );
};

export default ThreeDotIcon;
